export const iconFontAwesomeFilesFilePdf = (
	<i className="fa-solid fa-file-pdf"></i>
);
